export enum Currency {
  AUD = 1,
  USD,
}

export const currencyLabels: Record<Currency, string> = {
  [Currency.AUD]: 'AUD',
  [Currency.USD]: 'USD'
};
